export const mapButtonInlineViewToLoaderView = {
    primary: "custom",
    custom: "custom",
    secondary: "primary",
    tertiary: "custom",
    "primary-on-color": "primaryOnColor",
    "secondary-on-color": "custom",
} as const;
